
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function GalleryCTA() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section ref={ref} className="py-16 sm:py-20 px-4 sm:px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden"
        >
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/f49a0a9d8388340537c606a0893811ff.jpg"
              alt="Mercedes premium avec vue panoramique Alpes - Réserver chauffeur privé"
              title="Réservez votre transfert premium"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-night-blue/90 via-night-blue/70 to-night-blue/40"></div>
          </div>

          <div className="relative z-10 py-16 sm:py-20 px-8 sm:px-12 lg:px-16">
            <div className="max-w-xl">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
                  Vivez l&apos;Expérience <span className="text-voyage-gold">Premium</span>
                </h2>
                <p className="text-white/80 font-inter text-base sm:text-lg leading-relaxed mb-8">
                  Réservez votre transfert et profitez du confort de nos véhicules Mercedes avec chauffeur professionnel, disponible 24/7.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="flex flex-col sm:flex-row gap-4"
              >
                <a
                  href="/reservation"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-voyage-gold text-night-blue rounded-full font-inter font-bold text-sm hover:bg-white transition-all shadow-lg whitespace-nowrap cursor-pointer group"
                >
                  <i className="ri-calendar-check-line text-lg"></i>
                  Réserver Maintenant
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </a>
                <a
                  href="https://wa.me/33605606006"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#25D366] text-white rounded-full font-inter font-bold text-sm hover:bg-[#20BA5A] transition-all shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-lg"></i>
                  WhatsApp
                </a>
              </motion.div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
